import { BREADCRUMBS_GET_SUCCESS } from '../actionTypes/PDPBreadcrumbsActionTypes';

export default function PDPBreadcrumbsReducer(state = {}, action) {
    switch (action.type) {
        case BREADCRUMBS_GET_SUCCESS: {
            return action.payload.breadcrumbsData || state;
        }
        default:
            return state;
    }
}
